import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import { grey, lightGreen, red } from '@mui/material/colors';
import { useWatch } from 'react-hook-form';
import { LenderFieldMap } from '@trnsact/trnsact-shared-types';
import { sanitizeFormKey } from 'modules/vendorOpportunity/dynamicLenderSubmissionMappings/lib';

interface Props {
  field: LenderFieldMap;
}

export const MappingStatusIcon = ({ field }: Props) => {
  const mappedValue = useWatch({
    name: `mappingsByLenderProperty.${sanitizeFormKey(field.lenderProperty!)}.mappedValue`,
  });

  const isMapped = !!mappedValue || mappedValue === 0;
  const isRequired = field.details?.required === 'REQUIRED';
  let hasErrors = !!field.details?.errors?.length;

  if (field.details?.fieldInputType === 'OPTION_SET' && isMapped) {
    const validOption = field.details.optionSets?.find(option => option?.lenderValue === mappedValue);
    hasErrors = !validOption;
  }

  if (!isMapped) {
    return (
      <>
        {isRequired ? (
          <>
            <CancelIcon sx={{ color: red[500] }} />
            <ArrowRightAltIcon sx={{ color: grey[400] }} />
          </>
        ) : (
          <>
            <CancelIcon sx={{ color: grey[400] }} />
            <ArrowRightAltIcon sx={{ color: grey[400] }} />
          </>
        )}
      </>
    );
  }

  return (
    <>
      {hasErrors ? (
        <>
          <CancelIcon sx={{ color: red[500] }} />
          <ArrowRightAltIcon sx={{ color: grey[400] }} />
        </>
      ) : (
        <>
          <CheckCircleIcon sx={{ color: lightGreen[500] }} />
          <ArrowRightAltIcon sx={{ color: lightGreen[500] }} />
        </>
      )}
    </>
  );
};
